import React, {FC} from 'react';

import {
  CalendarEventVersionModel,
  CalendarEventVersionResponse,
} from '../../../models/api/calendarEventVersionModel';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {
  CalendarEventResponseHandler,
  CalendarInviteViewerResponse,
} from '../../inboxes/viewer/activity/calendarInvite/calendarInviteViewerResponse';

/*
 * Props.
 */

interface CalendarEventViewerFooterProps {
  calendarEventData: CalendarEventData;
  response: CalendarEventVersionResponse;
  onResponseClick: CalendarEventResponseHandler;
  masterCalendarEventVersion?: CalendarEventVersionModel;
}

/*
 * Component.
 */

export const CalendarEventViewerFooter: FC<CalendarEventViewerFooterProps> = (props) => {
  const {calendarEventData, response, onResponseClick, masterCalendarEventVersion} = props;
  const {channel, calendarEvent} = calendarEventData;

  if (!channel) {
    return null;
  }

  return (
    <CalendarInviteViewerResponse
      replyChannel={channel}
      response={response}
      updateCalendarEventResponse={onResponseClick}
      shouldHideAddress
      shouldUseMultiline
      calendarEvent={calendarEvent}
      shouldShowRecurringPrompt
      masterCalendarEventVersion={masterCalendarEventVersion}
    />
  );
};
